import { call, put } from 'redux-saga/effects';
import { delay } from 'redux-saga'
import Http from '../../../libs/Http';
import { updateSavedViewDate } from './Trades.helper';
import config from '../../../../../config';
import Auth from "../../../libs/Auth";

function formatFilters(filters) {
  if (filters.date) {
    // https://stackoverflow.com/questions/7556591/javascript-date-object-always-one-day-off
    const d = new Date(filters.date);
    const date = new Date(d.getTime() - d.getTimezoneOffset() * -60000);

    filters = {
      ...filters,
      startDate: date.setHours(0, 0, 0, 0),
      endDate: date.setHours(23, 59, 59, 999),
    };
  }

  return filters;
}

// export function* fetchOpenTrades(action) {
//   const { payload, meta } = action;
//   yield put({ type: 'REFRESHING_DATA' });
//   if (!payload.fastLoad) {
//     yield delay(250); // debounce
//   }
//   yield put({ $global: true, type: 'START_LOADER' });
//   const filters = {
//     ...payload.filters,
//     openStatus: 'yes',
//   };
//
//   const data = yield call(Http.get, '/admin/trades', {
//     query: {
//       page: payload.page,
//       filters: JSON.stringify(formatFilters(filters)),
//     }
//   });
//   yield put({
//     // $global: true,
//     type: 'SET_TRADES',
//     payload: data
//   });
//
//   yield put({ $global: true, type: 'STOP_LOADER' });
// }

// export function* fetchCompletedTrades(action) {
//   const { payload, meta } = action;
//   yield put({ type: 'REFRESHING_DATA' });
//   if (!payload.fastLoad) {
//     yield delay(250); // debounce
//   }
//   yield put({ $global: true, type: 'START_LOADER' });
//
//   const data = yield call(Http.get, '/admin/trades', {
//     query: {
//       page: payload.page,
//       filters: JSON.stringify(formatFilters(payload.filters)),
//     }
//   });
//   yield put({
//     // $global: true,
//     type: 'SET_TRADES',
//     payload: data
//   });
//
//   yield put({ $global: true, type: 'STOP_LOADER' });
// }

export function* downloadTrades(action) {
  const { payload, meta } = action;
  let filters = payload.filters;
  const token = Auth.getToken();
  let url = `${config.api.default}/admin/tradesCsv?filters=${encodeURIComponent(JSON.stringify(formatFilters(filters)))}&&token=${encodeURIComponent(token)}`;
  // window.open(url, '_blank');
  window.location = url;
}

export function* fetchTrades(action) {
  const { payload, meta } = action;
  const context = payload.context;
  yield put({ type: 'REFRESHING_DATA' });
  if (!payload.fastLoad) {
    yield delay(250); // debounce
  }
  yield put({ $global: true, type: 'START_LOADER' });
  let filters = payload.filters;
  if(context === 'open') {
    filters = {
      ...payload.filters,
      openStatus: 'yes',
    };
  }
  const data = yield call(Http.get, '/admin/trades', {
    query: {
      page: payload.page,
      filters: JSON.stringify(formatFilters(filters)),
    },
  });
  let trades = data.trades;
  if(context === 'open'){
    trades = trades.reverse();
  }
  updateSavedViewDate(trades);
  yield put({
    // $global: true,
    type: 'SET_TRADES',
    payload: {
      ...data,
      lastFetchedTrades: Date.now(),
      trades,
    }
  });

  if (data.paxfulApiError) {
    yield put({
      $global: true,
      type: 'ERROR',
      error: true,
      payload: {
        message: data.paxfulApiError,
      }
    });
  }

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* refreshTrade(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/admin/refreshTrade', {
    query: {
      tradeId: payload.tradeId,
    }
  });
  yield put({ type: 'TRADE_UPDATED', payload });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* updateTradeDetails(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/admin/updateTrade', {
    body: {
      _id: payload._id,
      tradeId: payload.tradeId,
      data: payload.data,
    }
  });
  yield fetchTrades(action);
  yield put({ type: 'TRADE_UPDATED', payload });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* updateTradeField(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/admin/updateTradeField', {
    body: {
      _id: payload._id,
      field: payload.field,
      value: payload.value,
    }
  });
  yield fetchTrades(action);
  yield put({ type: 'TRADE_UPDATED', payload });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* tradeMessageSubmit(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/admin/sendMessage', {
    body: {
      tradeId: payload.tradeId,
      message: payload.message,
    }
  });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* submitFileUpload(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/files/uploadImage', {
    multipart: true,
    query: {
      tradeId: payload.tradeId,
    },
    body: payload.data,
  });

  payload.onComplete && payload.onComplete(data.file);

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* tradeDisputeMessageSubmit(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield put({
    type: 'TOGGLE_DISPUTE_MODAL',
    payload: {
      active: false,
    }
  });

  const data = yield call(Http.post, '/admin/disputeTrade', {
    body: {
      tradeId: payload.tradeId,
      reason: payload.message,
      reason_type: payload.reason_type,
    }
  });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* tradeReleaseFunds(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  if (payload.info && payload.info.releaseType) {
    yield call(Http.post, '/payments/setPaymentInfo', {
      body: {
        tradeId: payload.tradeId,
        info: payload.info,
      }
    });
  }

  const data = yield call(Http.post, '/admin/releaseTrade', {
    body: {
      tradeId: payload.tradeId,
    }
  });
  yield put({ $global: true, type: 'STOP_LOADER' });
  yield put({ type: 'REFRESH_DATA' });
}

export function* tradeMarkAsPaid(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/admin/markAsPaid', {
    body: {
      tradeId: payload.tradeId,
    }
  });
  yield put({ $global: true, type: 'STOP_LOADER' });
  yield put({ type: 'REFRESH_DATA' });
}

export function* tradeCancel(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/admin/cancelTrade', {
    body: {
      tradeId: payload.tradeId,
    }
  });
  yield put({ $global: true, type: 'STOP_LOADER' });
  yield put({ type: 'REFRESH_DATA' });
}

export default function* ({ takeEvery, takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_TRADES', fetchTrades),
    takeLatest('DOWNLOAD_TRADES', downloadTrades),
    // takeLatest('FETCH_OPEN_TRADES', fetchOpenTrades),
    // takeLatest('FETCH_COMPLETED_TRADES', fetchCompletedTrades),
    takeFirst('UPDATE_TRADE_DETAILS', updateTradeDetails),
    takeFirst('UPDATE_TRADE_FIELD', updateTradeField),
    takeFirst('TRADE_MESSAGE_SUBMIT', tradeMessageSubmit),
    takeFirst('TRADE_DISPUTE_MESSAGE_SUBMIT', tradeDisputeMessageSubmit),
    takeFirst('TRADE_RELEASE_FUNDS', tradeReleaseFunds),
    takeFirst('TRADE_MARK_AS_PAID', tradeMarkAsPaid),
    takeFirst('TRADE_CANCEL', tradeCancel),
    takeFirst('REFRESH_TRADE', refreshTrade),
    takeFirst('SUBMIT_FILE_UPLOAD', submitFileUpload),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/Trades.sagas.js